import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';

@Component({
  standalone: false,
  selector: 'wr-deprecated-select',
  templateUrl: './deprecated-select.component.html',
  styleUrl: './deprecated-select.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DeprecatedSelectComponent),
      multi: true,
    },
  ],
})
export class DeprecatedSelectComponent extends AbstractFormControl<boolean | null> {

}
